$(document).ready(function () {
    $(window).scroll(function () {
        if (!$.cookie("newsletter_modal")) {
            if (window.pageYOffset > $(window).height() / 2) {
                $(".newsletter").fadeIn();
            }
        }
    });

    $(".newsletter .close").click(function () {
        var date = new Date();
        var days = 7;
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        $.cookie("newsletter_modal", true, { path: '/', expires: date });
        $(".newsletter").fadeOut();
    });

    if (!$.cookie("cookie_bar")) {
        $(".cookies").fadeIn();
    }
    $(".cookies .accept").click(function () {
        $.cookie("cookie_bar", true, { path: '/', expires: 30 });
        $(".cookies").fadeOut();
    });
});
